import React, { useCallback, useState } from 'react'
import { Link } from 'components'
import { useResetPassword } from 'api'
import { PasswordResetEmailForm } from './PasswordResetEmailForm'
import { LoginWrapper } from '../LoginWrapper'
import classes from './PasswordResetPage.module.scss'
import { useTranslation } from 'react-i18next'

export const PasswordResetEmailPage = () => {
  const [email, setEmail] = useState<string>('')
  const [mutate, { status }] = useResetPassword()
  const { t } = useTranslation()

  const onSubmit = useCallback(
    (values, { setSubmitting }) => {
      mutate({ email: values.email })
      setEmail(values.email)
      setSubmitting(false)
    },
    [mutate]
  )

  return (
    <LoginWrapper
      title={
        status === 'success' || status === 'failure'
          ? `${t(
              'pages.login.passwordResetPage.passwordResetEmailPage.title.passwordResetRequested'
            )}`
          : `${t(
              'pages.login.passwordResetPage.passwordResetEmailPage.title.passwordReset'
            )}`
      }
    >
      {status === 'success' || status === 'failure' ? (
        <>
          <p>
            {t(
              'pages.login.passwordResetPage.passwordResetEmailPage.info.emailIsSended',
              { email }
            )}
          </p>
          <p>
            {t(
              'pages.login.passwordResetPage.passwordResetEmailPage.info.confirmEmailReceive'
            )}
          </p>
        </>
      ) : (
        <>
          <p>
            {t(
              'pages.login.passwordResetPage.passwordResetEmailPage.info.enterRegisterEmail'
            )}
          </p>
          <div className={classes.form}>
            <PasswordResetEmailForm onSubmit={onSubmit} />
          </div>
        </>
      )}

      <p className={classes.link}>
        <Link to="/login">{t('global.returnToLogin')}</Link>
      </p>
    </LoginWrapper>
  )
}
